module.exports = "button {\n  margin: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.scss
// module id = ./src/app/login/login.component.scss
// module chunks = main